import { useEffect, useRef } from "react";

/** Fecha popovers com Esc ou clique fora de todos os refs informados. */
export const useDismiss = (open, refs, onDismiss) => {
    const onDismissRef = useRef(onDismiss);
    onDismissRef.current = onDismiss;
    const refsRef = useRef(refs);
    refsRef.current = refs;

    useEffect(() => {
        if (!open) return undefined;
        const onPointer = (event) => {
            if (refsRef.current.every((ref) => !ref.current?.contains(event.target))) onDismissRef.current();
        };
        const onKey = (event) => {
            if (event.key === "Escape") onDismissRef.current();
        };
        document.addEventListener("mousedown", onPointer);
        document.addEventListener("keydown", onKey);
        return () => {
            document.removeEventListener("mousedown", onPointer);
            document.removeEventListener("keydown", onKey);
        };
    }, [open]);
};
